/* eslint-disable angular/controller-name, angular/controller-as */

angular.
module("dx.webapp.node").
controller("DxNodeListRouteController", function NodeListRouteController(
	$scope,
	$rootScope,
	$location,
	$filter,
	$timeout,

	NodeRepository,
	Node,
	dxLocalize,
	NodeTypeEnum,
	QualityStatusEnum,
	DX_URLS
) {
	"use strict";

	$scope.nodes = [];
	$scope.filteredNodes = [];

	$scope.filterObject = {
		freemium: false,
		archived: false,
		qualityStatus: "",
		type: "",
	};

	$scope.node = new Node();
	$scope.showArchived = false;
	$scope.checkboxes = {};
	$scope.options = {};
	$scope.limit = 100;

	var scopeDestroyed = false;
	var renderingTimeout = null;

	NodeRepository.list().then(function list(response) {
		for (var i = 0; i < response.nodes.length; i++) {
			$scope.nodes.push(new Node(response.nodes[i]));
		}

		$scope.renderList();
	});

	$scope.renderList = function renderList() {
		$scope.limit = 100;

		$scope.filteredNodes = $filter("filter")($scope.nodes, $scope.filterObject);
		$scope.filteredNodes = $filter("orderBy")($scope.filteredNodes, "title");

		if (!scopeDestroyed && !renderingTimeout) {
			renderingTimeout = $timeout(renderingTimeoutCallback);
		}

		function renderingTimeoutCallback() {
			$scope.limit += 100;

			if (!scopeDestroyed && $scope.filteredNodes.length > $scope.limit) {
				$timeout(renderingTimeoutCallback);
			} else {
				renderingTimeout = null;
			}
		}
	};

	$scope.$on("$destroy", function onDestroy() {
		scopeDestroyed = true;
	});


	$scope.savedNodeHandler = function savedNodeHandler(response) {
		var node = new Node(response);
		$scope.nodes.push(node);
		$scope.renderList();
		$scope.node = new Node();
		$rootScope.$broadcast("notification:success", dxLocalize.get("TheOrganizationXHasBeenCreated", node.title));
	};

	$scope.options.freemium = [
		{value: "", name: dxLocalize.get("AllOrganizations")},
		{value: true, name: dxLocalize.get("Freemium")},
		{value: false, name: dxLocalize.get("NonFreemium")},
	];

	$scope.options.organization = [
		{value: "", name: dxLocalize.get("AllOrganizationTypes")},
		{value: NodeTypeEnum.NOTSPECIFIED, name: dxLocalize.get("NodeType." + NodeTypeEnum.NOTSPECIFIED)},
		{value: NodeTypeEnum.INTERNAL, name: dxLocalize.get("NodeType." + NodeTypeEnum.INTERNAL)},
		{value: NodeTypeEnum.HIGHEREDUCATION, name: dxLocalize.get("NodeType." + NodeTypeEnum.HIGHEREDUCATION)},
		{value: NodeTypeEnum.SECONDARTEDUCATION, name: dxLocalize.get("NodeType." + NodeTypeEnum.SECONDARTEDUCATION)},
		{value: NodeTypeEnum.PRIMARYEDUCATION, name: dxLocalize.get("NodeType." + NodeTypeEnum.PRIMARYEDUCATION)},
		{value: NodeTypeEnum.EDUCATIONCOMPANY, name: dxLocalize.get("NodeType." + NodeTypeEnum.EDUCATIONCOMPANY)},
	];

	$scope.options.qualityStatus = [
		{value: "", name: dxLocalize.get("UnspecifiedQualityStatus")},
		{value: QualityStatusEnum.NOTVERIFIED, name: dxLocalize.get("QualityStatus." + QualityStatusEnum.NOTVERIFIED)},
		{value: QualityStatusEnum.VERIFIED, name: dxLocalize.get("QualityStatus." + QualityStatusEnum.VERIFIED)},
		{value: QualityStatusEnum.JUNK, name: dxLocalize.get("QualityStatus." + QualityStatusEnum.JUNK)},
	];

	$scope.goToMergeTool = function goToMergeTool() { // eslint-disable-line consistent-return
		var selectedNodes = [];

		$scope.filteredNodes.forEach(function foreach(node) {
			if ($scope.checkboxes[node.id]) {
				selectedNodes.push(node.id);
			}
		});

		if (selectedNodes.length) {
			return $location.path(DX_URLS.get("nodeMerge", {id: selectedNodes}));
		}
	};

	$scope.isMergeButtonDisabled = function isMergeButtonDisabled() {
		var selectedNodes = [];

		$scope.filteredNodes.forEach(function foreach(node) {
			if ($scope.checkboxes[node.id]) {
				selectedNodes.push(node.id);
			}
		});

		return selectedNodes.length < 2;
	};
});
